module.exports = __webpack_public_path__ + "static/media/mc.7b8090d0.svg";